import { type CuratedItem, getAudio } from "~types/types";

export const filterForStoriesWithAudio = (items: CuratedItem[]) =>
    items?.filter((item) => getAudio(item));
